import BookingCancelledContainer from './BookingCancelledContainer'

const BookingCancelled = () => {
  return (
    <div className='page-body'>
      <BookingCancelledContainer />
    </div>
  )
}

export default BookingCancelled